export const getStyles = () => ({
  appBar: {
    backgroundColor: "transparent",
    position: "absolute",
    width: "100%",
    top: 0,
    left: 0,
    zIndex: 10,

    "@media (min-width: 960px)": {
      backgroundColor: "transparent",
    },
  },
  toolbar: {
    justifyContent: "space-between",
    paddingInline: "16px",

    "@media (min-width: 960px)": {
      paddingInline: "48px",
    },
  },
  logo: {
    height: "32px",
    cursor: "pointer",

    "& img": {
      height: "100%",
      width: "auto",
      objectFit: "contain",
    },

    "@media (min-width: 960px)": {
      height: "40px",
    },
  },
  menuStyles: {
    display: "block",

    "& .MuiList-root": {
      borderRadius: "24px",
      padding: "16px 12px",
    },

    "@media (min-width: 960px)": {
      display: "none",
    },
  },
  menuItemStyles: {
    "&:not(:last-child)": {
      borderBottom: "1px solid #B4B4B5",
    },
  },
  menuButton: {
    display: { xs: "flex", md: "none" },
    padding: "8px",
    width: "52px",
    height: "52px",

    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
  },
  navLinks: {
    display: { xs: "none", md: "flex" },
    gap: 1,

    "& .MuiButtonBase-root": {
      border: "none",
    },
  },
});
